<template>
  <div class="main has-header has-footer">
    <div v-if="!isLoading">
      <mt-header fixed title="详情">
        <router-link to="" slot="left">
          <mt-button icon="back" @click.native="$router.back(-1)"></mt-button>
        </router-link>
      </mt-header>
      <div class="currency-bg task-wrap">
        <div class="task">
          <div class="wrap">
            <div class="pannel-header">
              <div class="name">
                <!-- <i class="bg-red icon"></i> -->
                {{ task.companyName }}
              </div>
              <span
                v-if="task.userTaskState == 0 || task.userTaskState == 1"
                class="status txt-red border-red"
                >未签约</span
              >
<!--              <span-->
<!--                v-else-if="task.userTaskState == 1"-->
<!--                class="status nosigning txt-orange border-orange"-->
<!--                >未签约</span-->
<!--              >-->
              <span v-else-if="task.userTaskState === 3" class="status success"
                ><img src="../../assets/images/task/SignSuccess.png" alt=""
              /></span>
            </div>
            <div class="pannel-body">
              <div class="col col-left">
                <img src="../../assets/images/task/Frame.png" alt="" />
              </div>
              <div class="col col-right">
                <div class="title">{{ task.taskName }}</div>
                <div class="time">{{ task.createDate }}</div>
                <div class="tip txt-red">{{ task.priceDesc }}</div>
              </div>
            </div>
            <!-- <div class="line">
              <span class="txt-gray-lighter lable">发包企业：</span
              ><span class="txt-gray-light info">{{ task.companyName }}</span>
            </div>
            <div class="line">
              <span class="txt-gray-lighter lable">发包时间：</span
              ><span class="txt-gray-light info">{{ task.createDate }}</span>
            </div> -->
          </div>
          <!-- <hr class="space" /> -->
          <div class="task-blurb">
            <div class="txt-black">任务简介</div>
            <div class="detail">
              {{ task.taskDesc }}
            </div>
          </div>
          <div>
<!--            <div-->
<!--              class="receiveTask"-->
<!--              v-if="task.userTaskState == 0"-->
<!--              @click="handleToReceive"-->
<!--            ></div>-->
            <!-- <mt-button
          v-if="task.userTaskState == 0"
          type="danger"
          size="large"
          @click="handleToReceive"
          >领取任务</mt-button
        > -->
            <mt-button
              v-if="task.userTaskState == 0 || task.userTaskState == 1"
              type="danger"
              size="large"
              @click="handleToSign"
              >去签约</mt-button
            >
            <mt-button
              v-else
              type="danger"
              size="large"
              @click="handleToContract"
              >
              <img src="../../assets/images/task/preview.png" height="20" width="20" slot="icon">
              查看签约</mt-button
            >
          </div>
        </div>
      </div>
      <div class="loading" v-if="isLoading">
        <img src="@/assets/loading.gif" alt="" />
        <P>正在加载中···</P>
      </div>
    </div>
  </div>
</template>

<script>
import { getTaskDetail, receiveTask } from "@api/tasks";
import { formatDate } from "@utils/common";
import { Toast } from "mint-ui";
export default {
  components: {},
  props: ["id"],
  data() {
    //这里存放数据
    return {
      task: {},
      isLoading: false,
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    handleToReceive() {
      this.isLoading = true;
      this.handleTask("/task/to-sign/" + this.id);
    },
    handleToSign() {
      this.$router.replace("/task/to-sign/" + this.id);
      // this.handleTask('/task/to-sign/'+this.id)
    },
    handleToContract() {
      this.$router.push("/task/mySigns/" + this.id);
    },
    handleTask(url) {
      let data = {
        taskId: this.id - 0,
        state: this.task.userTaskState - 0 + 1 || 0,
        userId: this.$store.getters.getUser.userId,
        source: 1,
      };
      receiveTask(data)
        .then((res) => {
          if (res.code === 200) {
            this.isLoading = false;
            this.task.userTaskState = res.data;
            this.$router.push(url);
          } else {
            this.isLoading = false;
            Toast(res.message);
          }
        })
        .catch((err) => {
          this.isLoading = false;
          Toast("领取失败");
        });
    },
  },
  mounted() {
    let data = {
      taskId: this.id,
    };
    getTaskDetail(data).then((res) => {
      this.task = res.data;
      this.task.createDate = formatDate(
        new Date(res.data.createDate),
        "yyyy-MM-dd HH:mm:ss"
      );
    });
  },
};
</script>

<style lang='less' scoped>
.mint-button--danger {
  background-color: #26a2ff !important;
}
.wrap {
  padding: 20px 20px 0;
  // background-color: #fff;
  position: relative;
}

.pannel-header {
  padding: 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .name {
    display: block;
    line-height: 18px;
    font-weight: 900;
    font-size: 16px;
    color: #000;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .status {
    white-space: nowrap;
    display: inline-block;
    padding: 0 6px;
    height: 21px;
    // border: 1px solid rgba(201, 46, 38, 1);
    font-size: 14px;
    font-weight: 700;
    color: #b8bce4;
    display: flex;
    align-items: center;
    justify-content: center;
    line-height: 1;
    flex-shrink: 0;
  }
  .nosigning {
    color: #de7d00;
  }
  .success {
    img {
      width: 50px;
      height: 50px;
    }
  }
}

.intro {
  .detail {
    padding-bottom: 130px;
  }
}
.loading {
  position: absolute;
  left: 42%;
  top: 35%;
  P {
    margin-left: -14px;
  }
}

.receiveTask {
  width: 100vw;
  height: 16vh;
  margin: auto;
  background: url("../../assets/images/task/receiveTask.png") no-repeat;
  background-size: 100% 100%;
  position: fixed;
  bottom: 0;
}

.task-wrap {
  padding-top: 20px;
}
.task {
  background: url("../../assets/images/task/task-datail.png") no-repeat;
  background-size: cover;
}
.pannel-body {
  padding: 0 12px;
  font-size: 1rem;
  min-height: 5.5rem;
  display: flex;
  .col {
    // float: left;
    &.col-left {
      // width: 67%;
      min-width: 40px;
      margin-right: 10px;
      img {
        width: 40px;
        height: 40px;
      }
    }
    &.col-right {
      // width: 33%;
      // text-align: right;
      .min {
        font-size: 0.8rem;
      }
    }
  }
  .title {
    word-break: break-all;
    // font-weight: bold;
    font-size: 16px;
    line-height: 1.5rem;
    // margin-bottom: 15px;
  }
  .intro {
    color: #666;
    font-size: 1rem;
    line-height: 1.8rem;
    min-width: 3.5rem;
    padding: 15px 0;
  }
  .time {
    margin: 5px 0;
    font-size: 12px;
    color: #000;
  }
  .tip {
    font-size: 14px;
    font-weight: 700;
    color: #3bafe5;
  }
}
.task-blurb {
  padding: 0 34px;
  .txt-black {
    font-weight: 700;
    padding: 30px 0 12px;
  }
}
</style>
